import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGenderFemale: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGenderFemale"><Path fillRule="evenodd" clipRule="evenodd" d="M5.5 8.5C5.5 4.91015 8.41015 2 12 2C15.5899 2 18.5 4.91015 18.5 8.5C18.5 11.7498 16.1151 14.4425 13 14.9236V17H16V19H13V22H11V19H8V17H11V14.9236C7.88491 14.4425 5.5 11.7498 5.5 8.5ZM12 4C9.51472 4 7.5 6.01472 7.5 8.5C7.5 10.9853 9.51472 13 12 13C14.4853 13 16.5 10.9853 16.5 8.5C16.5 6.01472 14.4853 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGenderFemale;
